import {makeStyles} from '@material-ui/core/styles';

export const TableStyles = makeStyles({
        root: {
            overflow: 'auto',
        },
        loading: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: 'rgba(0,0,0,0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        actions: {
            minWidth: '50vw', 
            minHeight:'60px', 
            marginTop: '30px', 
            display:'flex', 
            flexDirection:'row-reverse',
        },
        update: {
            marginRight: '20px',
        },
        storage: {
            marginRight:'20px', 
            fontWeight:600,
            paddingTop: '18px',
        },
        progress: {
            minWidth: '40%', 
            paddingTop:'14px',
        },
        title:
        {
            align: 'left',
            display: 'flex',
            marginLeft: '1%'
        }
    }
);